import { gql } from "@apollo/client";

export const GET_DRAFT_PREVIEW = gql`
  query GetDraftPreview($instagramUsername: String!) {
    draftPreview(instagramUsername: $instagramUsername) {
      id
      instagramUsername
      language
      hasRedirect
      redirectUrl
      hasIntroduction
      hasProfileHeader
      introductionText
      buttons {
        url
        text
        enabled
      }
      hasGallery
      galleryTitle
      galleryId
      galleryRedirect
      galleryDefaultRedirectUrl
      instagram {
        profileImageUrl
      }
      googleAnalytics
      googleAnalytics4
      pixel
      css
      style {
        buttonRadius
        buttonBorder
        buttonBorderColour
        buttonFontColour
        buttonBackground
        buttonOpacity
        buttonBoxShadowColour
        background
        fontColour
      }
      updatedAt
      prefetch
    }
  }
`;

export interface DraftPreviewButton {
  url: string;
  text: string;
  enabled: boolean;
}

export interface DraftPreviewStyle {
  buttonRadius: number | null;
  buttonBorder: number | null;
  buttonBorderColour: string | null;
  buttonFontColour: string | null;
  buttonBackground: string | null;
  buttonOpacity: number | null;
  buttonBoxShadowColour: string | null;
  background: string | null;
  fontColour: string | null;
}

export interface DraftPreview {
  id: string;
  instagramUsername: string;
  language: string | null;
  hasRedirect: boolean;
  redirectUrl: string | null;
  hasIntroduction: boolean;
  hasProfileHeader: boolean;
  introductionText: string | null;
  buttons: DraftPreviewButton[];
  hasGallery: boolean;
  galleryTitle: string | null;
  galleryId: string | null;
  galleryRedirect: boolean;
  galleryDefaultRedirectUrl: string | null;
  instagram: { profileImageUrl: string | null } | null;
  googleAnalytics: string | null;
  googleAnalytics4: string | null;
  pixel: string | null;
  css: string | null;
  style: DraftPreviewStyle | null;
  updatedAt: string;
  prefetch: boolean | null;
}

export interface GetDraftPreviewData {
  draftPreview: DraftPreview;
}

export interface GetDraftPreviewVariables {
  instagramUsername: string;
}
